/** 开放平台对外 API（与主站 soso 剥离） */
export const DEFAULT_REMOTE_API_ORIGIN = 'https://open.pluskeji.cn'

/**
 * API 根地址（不含末尾斜杠）
 * - 开发：'' → 相对路径，由 vue.devServerProxy 反代到开放平台后端
 * - 生产：DEFAULT_REMOTE_API_ORIGIN（可用 VUE_APP_API_BASE_URL 覆盖）
 */
export function getApiBaseUrl() {
  const raw = process.env.VUE_APP_API_BASE_URL
  if (raw != null && String(raw).trim() !== '') {
    const v = String(raw).trim()
    if (v === '/') return ''
    return v.replace(/\/+$/, '')
  }
  if (process.env.NODE_ENV === 'development') {
    return ''
  }
  return DEFAULT_REMOTE_API_ORIGIN
}

export function resolveApiUrl(path) {
  const p = path && String(path).startsWith('/') ? String(path) : `/${path || ''}`
  const base = getApiBaseUrl()
  if (!base) return p
  return `${base}${p}`
}
